import api from 'api'
import { ImpressaoAtendimentoInput } from 'api/ImpressaoAtendimentoIndividual'
import moment from 'moment'
import { defaultHandleError, downloadFile } from 'util/downloadFile'

const asFormat = (val) => moment(val).format('YYYY-MM-DD_hhmm')

export const downloadAtendimentoVacinacao = (input: ImpressaoAtendimentoInput) => {
  return api.atendimentoVacinacao
    .imprimirAtendimentoVacinacao(input)
    .then((response) => {
      downloadFile(new Blob([response.data]), `AtendimentoVacinacao_${asFormat(moment().toDate())}.pdf`)
      return response
    })
    .catch(defaultHandleError)
}
